import React from 'react'

interface NavbarBackIconProps {
  size?: number
  color?: string
  onClick?: () => void
  className?: string
}

const NavbarBackIcon: React.FC<NavbarBackIconProps> = ({
  size = 32,
  color = '#FFFFFF',
  onClick,
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    onClick={onClick}
    className={className}
    style={{ cursor: onClick ? 'pointer' : 'default' }}
    {...props}
  >
    <path
      d="M18 9L11 16L18 23"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default NavbarBackIcon
